import gql from 'graphql-tag';

export const PROJECT_FROM_LIST_FRAGMENT = gql`
  fragment ProjectFromList on Project {
    id
    type
    name
    status
    editedAt
    generatedGenerationTools
    projectFolder {
      id
    }
    lastModifyingUser {
      name
      email
    }
    favorite

    # "long-form" specific fields - needed to correctly show "Project type" table field value
    longForm {
      generationTool
      localizedLanguages
    }
  }
`;

export const PROJECT_FRAGMENT = gql`
  fragment Project on Project {
    id
    type
    name
    status
    editedAt
    generatedGenerationTools
    editorContent
    workspaceId
    accessState
    projectFolder {
      id
    }
    customerPersonas {
      brandVoice {
        id
        name
      }
      id
      name
    }
    contentTaxonomy {
      id
      name
    }
    lastModifyingUser {
      name
      email
    }
    state
    brandVoiceIdsForBrandTerms
  }
`;

export const FRAGMENT_PROJECT_FOR_SEARCH = gql`
  fragment ProjectForSearch on Project {
    id
    name
    lastModifyingUser {
      name
      email
    }
    projectFolder {
      id
      name
    }
    graphqlType
  }
`;
